import React from 'react';
import { classes } from './datepicker.st.css';
import { WeeklyDatePicker } from 'wix-ui-tpa/cssVars';
export const DatePicker = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(WeeklyDatePicker, {
    value: new Date(),
    onChange: () => {},
    dateIndication: _ref => {
      let {
        date,
        isSelected
      } = _ref;
      return date <= new Date() && !isSelected ? /*#__PURE__*/React.createElement("div", {
        className: "Indications",
        style: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "indication",
        style: {
          borderRadius: '50%',
          width: '3px',
          height: '3px',
          backgroundColor: '#7247FF'
        }
      })) : null;
    }
  }));
};
//# sourceMappingURL=index.js.map